import { useState } from "react";
import { Modal } from "react-bootstrap";
import { Button, Icon } from "../../shared";
import { useTranslation } from "react-i18next";
import "./OutOfServiceBanner.css";

const OutOfServiceBanner = () => {
  const { t } = useTranslation();

  const [isVisible, setIsVisible] = useState(true);

  const handleModalVisiblity = () => setIsVisible((crr) => !crr)

  return (
    <Modal
      show={isVisible}
      backdrop="static"
      keyboard={false}
      centered
      size="lg"
      className="out-of-service-banner"
      backdropClassName="backdrop-dark"
    >
      <Modal.Header className="out-of-service-header">
        <span className="out-of-service-icon">
          <Icon iconName="exclamation" />
        </span>
        <Modal.Title className="out-of-service-title">
          <span>{t("outageModal.serviceDownTitle.en")}</span>
          {" / "}
          <span>{t("outageModal.serviceDownTitle.ar")}</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="out-of-service-body">
        <div>
          <p className="out-of-service-description rtl">
            {t("outageModal.serviceDownMessage1.ar")}
          </p>
          <p className="out-of-service-description rtl">
            {t("outageModal.serviceDownMessage2.ar")}
          </p>
          <p className="out-of-service-description rtl">
            {t("outageModal.serviceDownMessage3.ar")}
          </p>
        </div>
        <hr />
        <div>
          <p className="out-of-service-description ltr">
            {t("outageModal.serviceDownMessage1.en")}
          </p>
          <p className="out-of-service-description ltr">
            {t("outageModal.serviceDownMessage2.en")}
          </p>
          <p className="out-of-service-description ltr">
            {t("outageModal.serviceDownMessage3.en")}
          </p>
        </div>
        <div className="pt-4">
          <Button action={handleModalVisiblity}>
            {t("outageModal.serviceDownMessageBtn.en")}
            {" / "}
            {t("outageModal.serviceDownMessageBtn.ar")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OutOfServiceBanner;
